import { RESET } from '../actionTypes';
import { contactActions } from '../reducer';

export default () => contactActions[RESET]();
